import { Spinner } from "react-bootstrap"
import "./Skeleton.css"
export const SkeletonLoader = () => {
    return <main className="skeleton-container">
        <Spinner animation="border" role="status">
            <span className="visually-hidden">Loading...</span>
        </Spinner>
    </main>

}